export var MODAL_IDS = {
    ACTIVITY: "activity-modal-containerId",
    ACCOUNT_DETAILS: "account-details-modal-containerId",
    STATEMENTS: "statements-modal-containerId",
    REWARDS: "rewards-modal-containerId",
    ACCOUNT_SERVICES: "account-services-modal-containerId",
    PROMOTIONS: "promotions-modal-containerId",
    MAKE_A_PAYMENT: "make-a-payment-modal-containerId",
    AUTOPAY: "autopay-modal-containerId",
};
export var activityModalContainerId = function (accountid) {
    return "".concat(MODAL_IDS.ACTIVITY).concat(accountid);
};
export var accountDetailsModalContainerId = function (accountId) {
    return "".concat(MODAL_IDS.ACCOUNT_DETAILS).concat(accountId);
};
export var statementsModalContainerId = function (accountId) {
    return "".concat(MODAL_IDS.STATEMENTS).concat(accountId);
};
export var rewardsModalContainerId = function (accountId) {
    return "".concat(MODAL_IDS.REWARDS).concat(accountId);
};
export var accountServicesModalContainerId = function (accountId) {
    return "".concat(MODAL_IDS.ACCOUNT_SERVICES).concat(accountId);
};
export var promotionsModalContainerId = function (accountId) {
    return "".concat(MODAL_IDS.PROMOTIONS).concat(accountId);
};
export var makeAPaymentModalContainerId = function (accountId) {
    return "".concat(MODAL_IDS.MAKE_A_PAYMENT).concat(accountId);
};
export var autopayModalContainerId = function (accountId) {
    return "".concat(MODAL_IDS.AUTOPAY).concat(accountId);
};
//# sourceMappingURL=modalContainerId.js.map